import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import ActionBtns from './ActionBtns';
import FormModal from './FormModal';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
// ─────────────────────────────────────────────────────────────────────────────
// 3. BRANDS PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const BrandsPage = ({ companyId }) => {
  const crud = useCRUD(brandController, companyId);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [form, setForm]         = useState({ name:'',code:'',description:'',website:'',country:'',status:'Active' });
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  const [errors, setErrors] = useState([]);

  const openAdd  = () => { setEditItem(null); setForm({ name:'',code:'',description:'',website:'',country:'',status:'Active' }); setErrors([]); setShowForm(true); };
  const openEdit = (r) => { setEditItem(r); setForm({...r}); setErrors([]); setShowForm(true); };

  const handleSave = async () => {
    setSaving(true); setErrors([]);
    const res = editItem ? await brandController.update(editItem.id,{...form,companyId}) : await brandController.create({...form,companyId});
    setSaving(false);
    if (res.success) { crud.show(res.message); setShowForm(false); crud.fetchAll(); }
    else setErrors(res.errors?.length?res.errors:[res.message]);
  };

  const columns = [
    { label:'Code', key:'code', render: v => <span style={{ fontFamily:'monospace', fontSize:12, color:C.orange }}>{v||'—'}</span> },
    { label:'Brand Name', key:'name', render: v => <div style={{ fontWeight:700 }}>{v}</div> },
    { label:'Country', key:'country', render: v => v||'—' },
    { label:'Website', key:'website', render: v => v ? <a href={v} target="_blank" rel="noreferrer" style={{ color:C.primary, fontSize:12 }}>{v}</a> : '—' },
    { label:'Status', key:'status', render: v => <StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r) => <ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,`"${r.name}"`)} /> },
  ];

  return (
    <div style={S.page}>
      {crud.ToastEl}{crud.Dialog}
      <PageHeader title="Brands" subtitle="Manage product brands" Icon={Boxes} color={C.orange}
        action={<button style={S.btnPri} onClick={openAdd}><Plus size={15}/> Add Brand</button>} />
      <div style={S.card}>
        <div style={{ padding:'14px 14px 0' }}><FilterBar search={crud.search} onSearch={crud.setSearch} /></div>
        <DataTable columns={columns} data={crud.data} loading={crud.loading} emptyTitle="No brands found"
          page={crud.page} totalPages={crud.totalPages} onPageChange={crud.setPage} total={crud.total} />
      </div>
      {showForm && (
        <FormModal title={editItem?'Edit Brand':'Add Brand'} onClose={()=>setShowForm(false)} onSave={handleSave} saving={saving}>
          <ErrList errors={errors} />
          <FormGrid>
            <FormField label="Brand Name *"><input style={S.input} value={form.name} onChange={e=>set('name',e.target.value)} /></FormField>
            <FormField label="Code"><input style={S.input} value={form.code} onChange={e=>set('code',e.target.value)} /></FormField>
            <FormField label="Country"><input style={S.input} value={form.country} onChange={e=>set('country',e.target.value)} /></FormField>
            <FormField label="Website"><input style={S.input} value={form.website} onChange={e=>set('website',e.target.value)} placeholder="https://" /></FormField>
            <FormField label="Status"><select style={S.select} value={form.status} onChange={e=>set('status',e.target.value)}><option>Active</option><option>Inactive</option></select></FormField>
            <FormField label="Description" col={2}><textarea style={S.textarea} value={form.description} onChange={e=>set('description',e.target.value)} /></FormField>
          </FormGrid>
        </FormModal>
      )}
    </div>
  );
};
export default BrandsPage;